<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0 text-center">Comissão</th>
        <th scope="col" class="border-0 text-center">Qt de orçamentos</th>
        <th scope="col" class="border-0 text-center">À vista</th>
        <th scope="col" class="border-0 text-center">À prazo</th>
        <th scope="col" class="border-0 text-center">Total</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in reports" :key="index" class="align-items-center">
        <td class="td-5 link">{{ row.name }}</td>
        <td class="td-2 text-right">{{ row.commision }}</td>
        <td class="td-2 text-center">{{ row.qt_quotations }}</td>
        <td class="td-1 text-right">{{ row.total_term }}</td>
        <td class="td-1 text-right">{{ row.total_cash }}</td>
        <td class="td-1 text-right">{{ row.grand_total }}</td>
      </tr>
      <tr v-if="reports.length === 0">
        <td colspan="7" class="no-content">Ainda não tem resultado.</td>
      </tr>
    </tbody>
    <!-- <import-modals/> -->
  </table>
</template>

<script>

export default {
  name: 'report-seller-table',
  components: {
  },
  props: {
    reports: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

</style>
